import { FiPlus } from 'react-icons/fi';
import styled from 'styled-components';
import { detailsBackground, outlineGray, primaryColor, subMenuDropdownBackground } from '../../../config/colors';
import common from '../../../styles/common';
import Button from '../../Button';

export const Wrapper = styled.div`
  min-width: 36rem;
  min-height: 25rem;
  position: relative;
  padding: 1.5rem;
  background-color: ${subMenuDropdownBackground};
`;

export const ContentWrapper = styled.div`
  margin-top: 2rem;
  // display: flex;
  // flex-direction: column;
`;

export const InputsWrapper = styled.div`
  flex: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-right: 1.5rem;
`;

export const ImageWrapper = styled.div`
  flex: 1;
`;

export const Input = styled.input`
  display: block;
  width: 100%;
  overflow: hidden;
  ${common.input}
`;

export const InputsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-column-gap: 1rem;
`;

export const GridItem = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.span`
  font-size: 0.8rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: gray;
  min-height:2.5em;
`;

export const NotesInput = styled.textarea`
  width: 100%;
  height: 150px;
  overflow-y: auto;
  border: 1.5px solid gainsboro;
  resize: none;
  padding: 0.5rem;
  border-radius: 0.5rem;
  line-height: 1.3;
  font-size: 1rem;
  font-style: inherit;
  outline: 0;
  ::placeholder {
    font-size: 0.75rem;
  }
`;

export const RemoveProjectBtn = styled(Button).attrs({
  wrapperStyle: {
    width: '200px',
    backgroundColor: detailsBackground,
  },
  textStyle: {
    color: primaryColor,
  },
})``;

export const InputComment = styled.div`
  font-size: 0.7em;
  padding-left: 12px;
  margin-bottom: 4px;
`;
